import { NavButtonType } from "./types";
export default function NavButton({
  icon,
  onClick,
  disabled
}: NavButtonType) {
  return <button className='btn h-10 w-10 min-w-[auto] border-none p-1 hover:bg-[#edf2f7] disabled:cursor-not-allowed disabled:opacity-50' aria-label='navigation button' type='button' onClick={onClick} disabled={disabled} data-sentry-component="NavButton" data-sentry-source-file="nav-button.tsx">
      {icon}
    </button>;
}